const tabs = {
  nav: {
    button: {
      shadow: '0px 0px 10px 30px rgba(255,255,255,0.6)',
      background: '{white}',
      width: '{sizes.l}',
    },
  },
  tab: {
    background: 'transparent',
    padding: '7px 14px 3.5px 14px',
    border: {
      width: '0',
    },
    color: '{gray.scale.900}',
    fontSize: '{sizes.s}',
    fontWeight: '600',
    disabled: {
      color: '#b4bece',
    },
    variation: {
      dropdown: {
        padding: '0.5rem {spacing.s}',
        transition: 'background 250ms',
      },
    },
    active: {
      borderBottom: 'solid 3.5px {primary.color}',
      paddingBottom: '{spacing.xs}',
    },
    inactive: {
      borderBottom: 'solid  3.5px transparent',
    },
    delimiter: {
      margin: '5px 0 0 0',
      paddingBottom: '7px',
      borderLeft: '0.1rem solid #c3c5c9',
    },
    hover: {
      borderColor: 'transparent',
    },
  },
  tablist: {
    border: {
      width: '0px',
      color: '{black}',
    },
  },
  container: {
    moreDropdown: {
      background: '{white}',
      zIndex: '{zIndex.dropdown}',
      shadow: '0 1px 24px 2px rgba(27, 23, 59, 0.05), 0 1px 4px 0 rgba(27, 23, 59, 0.11), 0 17px 12px -12px rgba(27, 23, 59, 0.28)',
      active: {
        color: '{primary.color}',

      },
    },
  },
};

export default tabs;
